/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */


// tab-switcher.js
document.addEventListener('DOMContentLoaded', () => {
  // Get all the tabs-nav__item buttons
  const tabItems = document.querySelectorAll('.tabs-nav__item');

  tabItems.forEach(tab => {
    tab.addEventListener('click', function () {
      // Get the aria-controls value from the clicked tab
      const ariaControls = tab.getAttribute('aria-controls');

      // Find the corresponding image-wrapper by id
      const targetId = 'image-wrapper-' + ariaControls;

      // Find all image-wrapper elements in the container
      const allImageWrappers = document.querySelectorAll('.left_image_container .image-wrapper');

      // Hide all image-wrappers with animation
      allImageWrappers.forEach(wrapper => {
        wrapper.classList.add('fade-out');  // Add fade-out class for animation
        wrapper.classList.remove('fade-in'); // Remove fade-in class if any
      });

      // After fading out, show the selected image-wrapper with animation
      const targetWrapper = document.getElementById(targetId);
      if (targetWrapper) {
        targetWrapper.classList.add('fade-in'); // Add fade-in class for animation
        targetWrapper.classList.remove('fade-out'); // Remove fade-out class if any
      }
    });
  });
});


/** shoppable section */
document.addEventListener('DOMContentLoaded', function () {
    const scroller = document.querySelector('.shoppable-video .scroller');
    const productListInner = document.querySelector('.shoppable-video .product-list__inner');
    const productItems = document.querySelectorAll('.shoppable-video .product-item');
    const nextButton = document.querySelector('.shoppable-video .prev-next-button--next');
    const prevButton = document.querySelector('.shoppable-video .prev-next-button--prev');

    if (!productItems.length) return;

    let currentIndex = 0;
    let debounceTimer = null;

    function setActive(index) {
      const isMobile = window.innerWidth < 768;

      productItems.forEach((item) => {
          item.classList.remove('active');

          // Pause non-active videos on mobile only
          if (isMobile) {
              const video = item.querySelector('video');
              if (video) {
                  video.pause();
                  video.muted = true;
              }
          }
      });

      if (productItems[index]) {
          productItems[index].classList.add('active');
          currentIndex = index;

          // Play active video on mobile only
          if (isMobile) {
              const activeVideo = productItems[index].querySelector('video');
              if (activeVideo) {
                  activeVideo.play().catch(() => {
                      activeVideo.muted = true;
                      activeVideo.play();
                  });
              }
          }
      }
  }

  // ------------------------
  // Mobile: IntersectionObserver on scroller
  // ------------------------
  if (window.innerWidth < 768) {
      setActive(0);

      if (scroller) {
          let pendingIndex = null;

          const observer = new IntersectionObserver((entries) => {
              entries.forEach(entry => {
                  if (entry.intersectionRatio >= 0.75) {
                      const index = Array.from(productItems).indexOf(entry.target);
                      if (index !== -1) pendingIndex = index;
                  }
              });

              // Debounce: only apply active class after scroll settles
              clearTimeout(debounceTimer);
              debounceTimer = setTimeout(() => {
                  if (pendingIndex !== null && pendingIndex !== currentIndex) {
                      setActive(pendingIndex);
                      pendingIndex = null;
                  }
              }, 80); // 80ms after scroll stops
          }, {
              root: scroller,
              threshold: [0.5, 0.75, 1.0]
          });

          productItems.forEach(item => observer.observe(item));
      }

  } else {
      // ------------------------
      // Desktop: Arrow buttons
      // ------------------------
      setActive(2);

      if (nextButton) {
          nextButton.addEventListener('click', () => {
              const next = Math.min(currentIndex + 1, productItems.length - 1);
              setActive(next);
              productItems[next].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          });
      }

      if (prevButton) {
          prevButton.addEventListener('click', () => {
              const prev = Math.max(currentIndex - 1, 0);
              setActive(prev);
              productItems[prev].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          });
      }
  }
});
/** end shoppable section */

/** video autoplay */
let videoInitialized = false;

function videoScroll() {
  if (window.location.pathname !== '/') return;
  const nativeVideo = document.querySelector('native-video');
  const video = nativeVideo?.querySelector('video');
  const button = document.querySelector('.video-wrapper__play-button');

  // If video not yet created, trigger click ONCE
  if (!video && button && !videoInitialized) {
    videoInitialized = true;
    button.click();
    return;
  }

  if (!video) return;

  const windowHeight = window.innerHeight;
  const videoHeight = video.clientHeight;
  const videoTop = video.getBoundingClientRect().top;

  const inView =
    videoTop <= windowHeight - videoHeight * 0.5 &&
    videoTop >= -videoHeight * 0.5;

  if (inView) {
    video.muted = true; // REQUIRED
    video.play().catch(() => {});
  } else {
    video.pause();
  }
}

window.addEventListener('load', videoScroll);
window.addEventListener('scroll', videoScroll);

/** end video autoplay */

/** product finder section */
document.querySelectorAll('.custom-dropdown').forEach(dropdown => {
   if (window.location.pathname !== '/' && !window.location.pathname.includes('/collections/') && window.location.pathname !== '/pages/shop-all') return;
  const toggle = dropdown.querySelector('.dropdown-toggle');
  const items = dropdown.querySelectorAll('.dropdown-menu li');

  toggle.addEventListener('click', () => {
    dropdown.classList.toggle('open');
  });

  items.forEach(item => {
    item.addEventListener('click', () => {
      toggle.textContent = item.textContent;
      dropdown.classList.remove('open');

      // store selected value
      dropdown.dataset.selected = item.dataset.value;
    });
  });
});

// Close dropdowns on outside click
document.addEventListener('click', e => {
  document.querySelectorAll('.custom-dropdown').forEach(dropdown => {
    if (!dropdown.contains(e.target)) {
      dropdown.classList.remove('open');
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  if (window.location.pathname !== '/' && !window.location.pathname.includes('/collections/') && window.location.pathname !== '/pages/shop-all') return;
  const radios = document.querySelectorAll('input[name="finder-type"]');
  const sections = document.querySelectorAll('.finder-section');
  const button = document.getElementById('find_match');

  // Toggle Hair / Skin sections
  radios.forEach(radio => {
    radio.addEventListener('change', () => {
      sections.forEach(section => {
        section.hidden = section.dataset.type !== radio.value;
      });
    });
  });

  // Redirect logic (UL / LI dropdowns)
  // Button JS updated by team searchtap
  if(!button) return;
  button.addEventListener('click', () => {
    let activeType; 
    const activeRadio = document.querySelector('input[name="finder-type"]:checked');
    if (!activeRadio) {
      const element = document.querySelector('.finder-section'); 
      activeType = element ? element.getAttribute('data-type') : null; 
    } else {
      activeType = activeRadio.value;
    }

    const activeSections = document.querySelectorAll(
      `.finder-section[data-type="${activeType}"]`
    );

    var concernDisabled = '';
    var productDisabled = '';


    activeSections.forEach(section => {
      // skip hidden section
      if (!section.offsetParent) return;

      const concernDropdown = section.querySelector(
        '.custom-dropdown[data-filter="concerns"]'
      );

      const productDropdown = section.querySelector(
        '.custom-dropdown[data-filter="product_type_finder"]'
      );

      concernDisabled = concernDropdown?.querySelector('li[data-disabled="true"]') ? concernDropdown : null;
      productDisabled = productDropdown?.querySelector('li[data-disabled="true"]') ? productDropdown : null;
    });

    

    const concern = concernDisabled?.dataset.selected || '';
    const productType = productDisabled?.dataset.selected || '';

    // Stop if nothing selected
    if (!concern && !productType) {
      alert('Please select at least one option');
      return;
    }

    const params = new URLSearchParams();

    if (activeType == "skin" && concern) {
      params.append('filter.p.m.custom.concerns', concern);
    }

    if (activeType == "skin" && productType) {
      params.append('filter.p.m.custom.product_type_finder', productType);
    }

    if (activeType == "hair" && concern) {
      params.append('filter.p.m.custom.hair_concerns', concern);
    }


    if (activeType == "hair" && productType) {
      params.append('filter.p.m.custom.hair_product_type_finder', productType);
    }

    localStorage.setItem("concern_type", activeType);
    window.location.href = `/collections/product-finder?concern_type=${activeType}&${params.toString()}&sort_by=created-descending`;
  });
});

function toggleConcerns() {
  if (!window.location.pathname.includes('/collections/product-finder')) return;
  const params = new URLSearchParams(window.location.search);
  const concernType =
    params.get('concern_type') || localStorage.getItem('concern_type');

  const skinEls = document.querySelectorAll('.skincare-concerns');
  const hairEls = document.querySelectorAll('.haircare-concerns');
  // If elements not yet loaded, stop
  if (!skinEls.length && !hairEls.length) return;

  // Hide both first
  skinEls.forEach(el => el.style.display = 'none');
  hairEls.forEach(el => el.style.display = 'none');

  if (concernType === 'skin') {
    skinEls.forEach(el => el.style.display = '');
  }

  if (concernType === 'hair') {
    hairEls.forEach(el => el.style.display = '');
  }
}

/* Run on initial load */
document.addEventListener("DOMContentLoaded", toggleConcerns);

/* Run again after Shopify filter AJAX reload */
document.addEventListener("facet:criteria-changed", function () {
  setTimeout(toggleConcerns, 1500); 
});

/* Fallback: slight delay in case filters render late */
setTimeout(toggleConcerns, 1000);

/** end product finder section */

/** mobile navigation */
document.addEventListener('click', function (e) {
  const openBtn = e.target.closest('.js-open-panel');
  if (openBtn) {
    const targetPanel = document.querySelector(`[data-panel="${openBtn.dataset.target}"]`);
    if (!targetPanel) return;


    const drawer = document.querySelector("mobile-navigation .drawer__content");
    drawer.classList.add('is-active');

    const parentPanel = document.querySelector(`[data-panel="${openBtn.dataset.parent}"]`);
    if (parentPanel) parentPanel.style.left = '-100%'; // hide parent

    targetPanel.classList.add('is-active');
    targetPanel.style.left = '0';
    return;
  }

  const backBtn = e.target.closest('.js-back');
  if (backBtn) {
    const currentPanel = backBtn.closest('.menu-panel');
    if (!currentPanel) return;

    currentPanel.classList.remove('is-active');
    currentPanel.style.left = '100%';

    const parentPanelName = currentPanel.dataset.parent;

    // If going back to level 1
    if (parentPanelName === "level-1") {
      const drawer = document.querySelector("mobile-navigation .drawer__content");
      drawer.classList.remove('is-active');
    } else {
      // Otherwise go back to previous panel
      const parentPanel = document.querySelector(
        `[data-panel="${parentPanelName}"]`
      );

      if (parentPanel) {
        parentPanel.classList.add('is-active');
        parentPanel.style.left = '0';
      }
    }
  }

});
/** end mobile navigation */


/** card variant */

function initializeSwatchUpdater() {
  const productLists = document.querySelectorAll(
    // ✅ Added recommendation selectors
    '.product-list, .product-facet__product-list, .product-recommendations, cart-drawer-recommendations, [data-section-type="product-recommendations"]'
  );

  if (productLists.length === 0) {
    return;
  }

  productLists.forEach(productList => {
    const productItems = productList.querySelectorAll('product-item, .product-item');

    productItems.forEach(productItem => {
      if (productItem.hasAttribute('data-swatch-initialized')) return;
      productItem.setAttribute('data-swatch-initialized', 'true');

      const swatchInputs = productItem.querySelectorAll('.color-swatch__radio');
      if (swatchInputs.length === 0) return;

      swatchInputs.forEach(input => {
        input.addEventListener('change', function () {
          if (this.checked) {
            const variantId = this.getAttribute('data-variant-id');
            updatePriceAndAtc(variantId, productItem);
          }
        });
      });
    });
  });
}


/**
 * Update price display and ATC button ID based on variant
 * @param {string} variantId - The selected variant ID
 * @param {HTMLElement} productContainer - The specific product container element
 */
function updatePriceAndAtc(variantId, productContainer) {
  if (!variantId || !productContainer) {
    console.error('Missing variantId or productContainer');
    return;
  }

  // Get variant data from the swatch itself or from a data attribute
  const selectedSwatch = productContainer.querySelector(`input[data-variant-id="${variantId}"]`);
  
  if (!selectedSwatch) {
    console.error('Variant not found:', variantId);
    return;
  }
  
  // Option 1: Get price from data attributes on the swatch
  const variantPrice = selectedSwatch.getAttribute('data-price');
  const variantComparePrice = selectedSwatch.getAttribute('data-compare-price');
  const variantDiscount = selectedSwatch.getAttribute('data-discount');
  
  // Option 2: Get price from a data attribute on the product item
  const variantDataStr = productContainer.getAttribute('data-variants');
  let variantData = null;
  
  if (variantDataStr) {
    try {
      const variants = JSON.parse(variantDataStr);
      variantData = variants[variantId];
    } catch (e) {
      console.error('Error parsing variant data:', e);
    }
  }
  
  // Update price elements within this specific product
  const priceElement = productContainer.querySelector('.price--highlight .money');
  const comparePriceElement = productContainer.querySelector('.price--compare .money');
  const discountElement = productContainer.querySelector('.discounted');
  
  // Update sale price - use innerHTML to preserve the money span structure
  if (priceElement && (variantPrice || variantData?.price)) {
    const newPrice = variantPrice || variantData.price;
    // If the price already contains HTML (like <span class="money">), use it as is
    if (newPrice.includes('<')) {
      priceElement.outerHTML = newPrice;
    } else {
      // Otherwise just update the text content
      priceElement.textContent = newPrice;
    }
  }
  
  // Update compare price
  if (comparePriceElement && (variantComparePrice || variantData?.comparePrice)) {
    const newComparePrice = variantComparePrice || variantData.comparePrice;
    if (newComparePrice.includes('<')) {
      comparePriceElement.outerHTML = newComparePrice;
    } else {
      comparePriceElement.textContent = newComparePrice;
    }
  }
  
  // Update discount
  if (discountElement && (variantDiscount || variantData?.discount)) {
    discountElement.textContent = variantDiscount || variantData.discount;
  }
  
  // Update ATC button/form with new variant ID
  updateAtcId(variantId, productContainer);
  
  // Optional: Trigger custom event for other scripts
  productContainer.dispatchEvent(new CustomEvent('variantChanged', { 
    detail: { 
      variantId: variantId,
      price: variantPrice || variantData?.price,
      comparePrice: variantComparePrice || variantData?.comparePrice
    },
    bubbles: true
  }));
  
  // console.log('Price updated for variant:', variantId);
}

/**
 * Update Add to Cart functionality with new variant ID
 * Scoped to specific product container
 * @param {string} variantId - The selected variant ID
 * @param {HTMLElement} productContainer - The specific product container element
 */
function updateAtcId(variantId, productContainer) {  
  // Update hidden input for variant ID (if exists - for ATC forms)
  const variantInput = productContainer.querySelector('input[name="id"][type="hidden"]');
  if (variantInput) {
    variantInput.value = variantId;
  }
  
  // Update any data attributes on ATC buttons (but don't change links)
  const atcButtons = productContainer.querySelectorAll('[data-add-to-cart]');
  atcButtons.forEach(button => {
    button.setAttribute('data-variant-id', variantId);
  });
}

/**
 * Utility: Refresh event listeners after dynamic content load
 * Call this if products are loaded via AJAX/infinite scroll
 */
function refreshSwatchListeners() {
  // console.log('Refreshing swatch listeners...');
  initializeSwatchUpdater();
}

/**
 * Observe for dynamically added products (for infinite scroll/AJAX loading)
 */
function observeProductList() {
  const productList = document.querySelector('.product-list, .product-facet__product-list, product-recommendations');
  
  if (!productList) {
    return;
  }
  
  const itemObserver = new MutationObserver((mutations) => {
    let hasNewProducts = false;
    
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1 && (node.matches('product-item, .product-item') || 
              node.querySelector('product-item, .product-item'))) {
            hasNewProducts = true;
          }
        });
      }
    });
    
    if (hasNewProducts) {
      // console.log('New products detected, reinitializing...');
      refreshSwatchListeners();
    }
  });
  
  itemObserver.observe(productList, {
    childList: true,
    subtree: true
  });
  
  return itemObserver;
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    initializeSwatchUpdater();
    observeProductList();
  });
} else {
  initializeSwatchUpdater();
  observeProductList();
}

// Listen for custom events from theme (for AJAX filtering/pagination)
document.addEventListener('collection:refresh', refreshSwatchListeners);
document.addEventListener('products:loaded', refreshSwatchListeners);

// Shopify theme-specific events
if (typeof Shopify !== 'undefined') {
  document.addEventListener('shopify:section:load', refreshSwatchListeners);
  document.addEventListener('shopify:section:reorder', refreshSwatchListeners);
}

// Export for use in other scripts if needed
if (typeof module !== 'undefined' && module.exports) {
  module.exports = {
    initializeSwatchUpdater,
    updatePriceAndAtc,
    updateAtcId,
    refreshSwatchListeners,
    observeProductList
  };
}

// Make functions available globally for manual triggering
window.swatchUpdater = {
  init: initializeSwatchUpdater,
  refresh: refreshSwatchListeners
};

/** end card product */

/** product finder filter */
function updateAllFacetButtons() {

  if (!window.location.pathname.includes('/collections/product-finder')) return;
  document.querySelectorAll('.product-facet__filter-item').forEach(function(item) {

    var toggleButton = item.querySelector('button[is="toggle-button"]');
    if (!toggleButton) return;

    var checkedInputs = item.querySelectorAll('input.checkbox:checked');

    // console.log("checkedInputs", checkedInputs);

    var values = Array.from(checkedInputs).map(function(input) {
      return input.value.trim();
    });

    var defaultText = toggleButton.getAttribute('data-default') ||
      toggleButton.childNodes[0].nodeValue.trim();

    var displayText = values.length ? values.join(', ') : defaultText;

    toggleButton.childNodes[0].nodeValue = " " + displayText + " ";
  });
}


// Run on first load
document.addEventListener('DOMContentLoaded', updateAllFacetButtons);

// Run whenever filters change
document.addEventListener('change', function(e) {
  if (e.target.matches('.product-facet__filter-item input.checkbox')) {
    setTimeout(updateAllFacetButtons, 1500);
  }
});


// Observe Shopify AJAX re-render
var facetContainer = document.querySelector('.product-facet__filter-list');

if (facetContainer) {
  var facetobserver = new MutationObserver(function() {
    updateAllFacetButtons();
  });

  facetobserver.observe(facetContainer, {
    childList: true,
    subtree: true
  });
}
/** end product finder filter */


/** infinite pagination */
document.addEventListener("DOMContentLoaded", function() {

  // ✅ Only run on collection pages
  if (!window.location.pathname.includes('/collections/')) return;

  function removeRevealFromProducts(container) {
    container = container || document;
    var items = container.querySelectorAll('.product-item');
    items.forEach(function(item) { 
      item.removeAttribute('reveal');
    });
  }

  // remove initially
  removeRevealFromProducts();

  // setup Ajaxinate with callback
  var endlessScroll = new Ajaxinate({
    method: 'scroll',
    container: '#AjaxinateContainer',
    pagination: '#AjaxinatePagination',
    callback: function() {
      removeRevealFromProducts();
    }
  });

  // optional: fallback on scroll
  window.addEventListener('scroll', function() {
    removeRevealFromProducts();
  });
});
/** end infinite pagination */

